import { push } from '@lagunovsky/redux-react-router'
import PropTypes from 'prop-types'
import React from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import { getSandreLabel } from 'utils/StringUtil'
import ColorfulCard from '../../components/card/ColorfulCard'
import { PATH_REFERENCIAL_CONTACT_LINK } from '../../home/constants/RouteConstants'
import DtoCampaignInstallationWithStats from '../../installation/components/campaign/dto/DtoCampaignInstallationWithStats'
import ContactDto from '../../referencial/components/contact/dto/ContactDto'
import { getColorCampaign } from '../../utils/CampaignUtil'
import { getDate } from '../../utils/DateUtil'
import { sieauTooltip } from '../../utils/FormUtils'
import CampaignDto from '../dto/CampaignDto'
import DtoCampaignProgress from '../dto/DtoCampaignProgress'
import { getCampaignIcon, getCampaignProgress, getProgressBar, getQualityCampaignIcon } from '../utils/CampaignUtils'
import Spinner from 'components/progress/Spinner'
import { Grid2 } from '@mui/material'
import { hasValue } from 'utils/NumberUtil'

const CampaignCard = ({
    progress = {},
    campaign = {},
    contact = {},
    stationType = '',
    onClickLink,
}) => {
    const {
        sandreCodes,
    } = useSelector(store => ({
        sandreCodes: store.ReferencialReducer.sandreCodes,
    }), shallowEqual)
    const dispatch = useDispatch()

    const {
        id,
        idCampaign,
        name,
        statut,
        isArchived,
        campaignType,
        beginningApplication,
        endingApplication,
        campaignStatus,
    } = campaign
    const {
        id: idProgress,
        nbStation = 0,
        nbStationValidated = 0,
        startDate,
        endDate,
        progress: progressValidated,
        progressTotal,
    } = progress

    const progressValue = getCampaignProgress(progressValidated, progressTotal)
    return (
        <ColorfulCard color={getColorCampaign(isArchived, progressValue, statut)} >
            <Grid2
                container
                className={`${statut === 1 ? 'grey lighten-2' : ''}`}
                sx={{
                    cursor: 'pointer',
                    height: '60px',
                }}
                spacing={1}
            >
                <Grid2
                    container
                    size={11}
                    onClick={() => dispatch(push(onClickLink || `/${stationType}/campaign/${id || idCampaign}`))}
                >
                    <Grid2 size={1} sx={{ placeContent: 'center' }} container justifyContent='center' alignItems='center'>
                        {stationType === 'quality' ? getQualityCampaignIcon(campaignType, 'medium') : getCampaignIcon(campaignType, 'medium')}
                    </Grid2>
                    <Grid2 container size={5} direction='column' justifyContent='center'>
                        <Grid2 sx={{ fontWeight: 'bold' }}>{name}</Grid2>
                        {
                            statut === 2 && (
                                <Grid2>{`${stationType === 'installation' ? i18n.nbInstallationsValidated : i18n.nbStationsValidated} : ${nbStationValidated} /${nbStation}`}</Grid2>
                            )
                        }
                    </Grid2>
                    <Grid2 size={3} container justifyContent='center' alignItems='center'>
                        <Grid2>{getSandreLabel(sandreCodes, 'CAMPAGNES.STATUT', statut || campaignStatus) ?? i18n.unknowStatus}</Grid2>
                    </Grid2>
                    {
                        statut === 1 && (
                            <Grid2 size={3} container justifyContent='center' alignItems='center'>
                                <i className='material-icons medium'>create</i>
                            </Grid2>
                        )
                    }
                    {(stationType === 'quality' && !hasValue(idProgress)) && (
                        <Grid2 size={3} container alignItems='center' sx={{ paddingLeft: '2rem' }}>
                            <Spinner />
                        </Grid2>
                    ) || (statut !== 1 && (
                        <Grid2 container size={3} direction='column' justifyContent='center'>
                            <Grid2>
                                {startDate ? getDate(startDate) : beginningApplication} - {endDate ? getDate(endDate) : endingApplication}
                            </Grid2>
                            {
                                statut === 2 && stationType === 'quality' && <Grid2>{getProgressBar(progressValidated, progressTotal, progressValue, i18n.analyseOn, i18n.analysisOn)}</Grid2>
                            }
                            {
                                statut === 2 && stationType !== 'quality' && <Grid2>{getProgressBar(progressValidated, progressTotal, progressValue)}</Grid2>
                            }
                        </Grid2>
                    ))}
                </Grid2>
                <Grid2 container size={1} justifyContent='center' alignItems='center'>
                    <Grid2
                        container
                        sx={{
                            cursor: 'pointer',
                        }}
                        {...sieauTooltip(contact.name || i18n.unknown, null, 'bottom')}
                        onClick={() => contact.code && dispatch(push(`${PATH_REFERENCIAL_CONTACT_LINK}${contact.code}`))}
                    >
                        <i className={'material-icons medium'}>account_circle</i>
                    </Grid2>
                </Grid2>
            </Grid2>
        </ColorfulCard>
    )
}

CampaignCard.propTypes = {
    campaign: PropTypes.oneOfType([
        PropTypes.instanceOf(CampaignDto),
        PropTypes.instanceOf(DtoCampaignInstallationWithStats),
    ]),
    progress: PropTypes.instanceOf(DtoCampaignProgress),
    contact: PropTypes.instanceOf(ContactDto),
    stationType: PropTypes.string,
    onClickLink: PropTypes.func,
}

export default CampaignCard
